/*
 * Cart shipping estimator (ShopAmerex, 2026-09-08).
 *
 * Quotes live shipping rates for the current cart from Shopify's own
 * /cart/shipping_rates.json, so the number a shopper sees here is the number
 * checkout will show. Re-quotes automatically after any cart change (add,
 * quantity change, remove) by watching the theme's cart requests.
 *
 * Markup comes from snippets/cart-shipping-estimate.liquid. The pre-ZIP status
 * (free / mixed / amount-to-go) is computed in Liquid; after a cart change the
 * element re-renders itself from the section response or, failing that, from
 * GET /cart?section_id=cart-shipping-estimate.
 */
(function () {
	'use strict';

	if (window.__saeBooted) {
		return;
	}
	window.__saeBooted = true;

	// USPS 3-digit ZIP prefix -> state. Shopify requires a province for US addresses.
	var RANGES = [
		[5, 5, 'NY'], [6, 7, 'PR'], [8, 8, 'VI'], [9, 9, 'PR'], [10, 27, 'MA'], [28, 29, 'RI'], [30, 38, 'NH'],
		[39, 49, 'ME'], [50, 59, 'VT'], [60, 69, 'CT'], [70, 89, 'NJ'], [90, 99, 'AE'], [100, 149, 'NY'],
		[150, 196, 'PA'], [197, 199, 'DE'], [200, 205, 'DC'], [206, 212, 'MD'], [214, 219, 'MD'], [220, 246, 'VA'],
		[247, 268, 'WV'], [270, 289, 'NC'], [290, 299, 'SC'], [300, 319, 'GA'], [320, 339, 'FL'], [340, 340, 'AA'],
		[341, 342, 'FL'], [344, 344, 'FL'], [346, 347, 'FL'], [349, 349, 'FL'], [350, 369, 'AL'], [370, 385, 'TN'],
		[386, 397, 'MS'], [398, 399, 'GA'], [400, 427, 'KY'], [430, 459, 'OH'], [460, 479, 'IN'], [480, 499, 'MI'],
		[500, 528, 'IA'], [530, 549, 'WI'], [550, 567, 'MN'], [569, 569, 'DC'], [570, 577, 'SD'], [580, 588, 'ND'],
		[590, 599, 'MT'], [600, 629, 'IL'], [630, 658, 'MO'], [660, 679, 'KS'], [680, 693, 'NE'], [700, 714, 'LA'],
		[716, 729, 'AR'], [730, 749, 'OK'], [750, 799, 'TX'], [800, 816, 'CO'], [820, 831, 'WY'], [832, 838, 'ID'],
		[840, 847, 'UT'], [850, 865, 'AZ'], [870, 884, 'NM'], [885, 885, 'TX'], [889, 898, 'NV'], [900, 961, 'CA'],
		[962, 966, 'AP'], [967, 968, 'HI'], [969, 969, 'GU'], [970, 979, 'OR'], [980, 994, 'WA'], [995, 999, 'AK']
	];
	var NOT_SERVED = { PR: 1, VI: 1, GU: 1, AS: 1, MP: 1, AA: 1, AE: 1, AP: 1 };

	var STORE_KEY = 'sae_zip';
	var SECTION_ID = 'cart-shipping-estimate';
	var rateCache = {};

	function stateForZip(zip) {
		if (zip === '96799') {
			return 'AS';
		}
		var prefix = parseInt(zip.slice(0, 3), 10);
		for (var i = 0; i < RANGES.length; i++) {
			if (prefix >= RANGES[i][0] && prefix <= RANGES[i][1]) {
				return RANGES[i][2];
			}
		}
		return null;
	}

	function cleanZip(raw) {
		var digits = String(raw || '').replace(/[^0-9]/g, '');
		return digits.length >= 5 ? digits.slice(0, 5) : '';
	}

	function money(amount) {
		var n = Number(amount);
		if (isNaN(n)) {
			return '';
		}
		return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	function esc(s) {
		return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
		});
	}

	function storedZip() {
		try {
			return cleanZip(localStorage.getItem(STORE_KEY));
		} catch (e) {
			return '';
		}
	}

	function storeZip(zip) {
		try {
			if (zip) {
				localStorage.setItem(STORE_KEY, zip);
			} else {
				localStorage.removeItem(STORE_KEY);
			}
		} catch (e) { /* private mode */ }
	}

	function wait(ms) {
		return new Promise(function (resolve) {
			setTimeout(resolve, ms);
		});
	}

	function fetchRates(zip, state, attempt) {
		attempt = attempt || 0;
		var qs = 'shipping_address[zip]=' + encodeURIComponent(zip) +
			'&shipping_address[country]=' + encodeURIComponent('United States') +
			'&shipping_address[province]=' + encodeURIComponent(state);

		return fetch('/cart/shipping_rates.json?' + qs, {
			headers: { 'Accept': 'application/json' },
			credentials: 'same-origin'
		}).then(function (r) {
			// Shopify may answer 202 while carrier rates are still being computed.
			if (r.status === 202 && attempt < 12) {
				return wait(1000).then(function () {
					return fetchRates(zip, state, attempt + 1);
				});
			}
			return r.text().then(function (text) {
				var data = null;
				try {
					data = text ? JSON.parse(text) : null;
				} catch (e) { /* not json */ }
				return { status: r.status, data: data };
			});
		});
	}

	function errorMessage(data) {
		if (!data || typeof data !== 'object') {
			return 'Could not get a rate right now. Shipping is calculated at checkout.';
		}
		var parts = [];
		Object.keys(data).forEach(function (k) {
			var v = data[k];
			if (Array.isArray(v)) {
				parts.push(v.join(', '));
			} else if (typeof v === 'string') {
				parts.push(v);
			}
		});
		var joined = parts.join(' ');
		if (/zip|postal/i.test(joined)) {
			return 'That ZIP code does not look right. Enter a 5-digit US ZIP.';
		}
		return joined || 'Could not get a rate right now. Shipping is calculated at checkout.';
	}

	class CartShippingEstimate extends HTMLElement {
		connectedCallback() {
			this.bind();
			this.autoQuote();
		}

		// Saved ZIP first, then the logged-in customer's address, then the location service (estimate).
		autoQuote() {
			if (this.dataset.gateFree === 'true') {
				return;
			}
			var zip = storedZip();
			if (zip) {
				this.setZipField(zip);
				this.quote(zip, true, 'saved');
				return;
			}
			var customerZip = cleanZip(this.dataset.customerZip);
			if (customerZip) {
				this.setZipField(customerZip);
				this.quote(customerZip, true, 'saved');
				return;
			}
			if (this.dataset.geoUrl) {
				this.geoQuote(this.dataset.geoUrl);
			}
		}

		geoQuote(url) {
			var self = this;
			var cached = null;
			try {
				cached = JSON.parse(sessionStorage.getItem('sae_geo') || 'null');
			} catch (e) { /* ignore */ }
			if (cached && cached.zip) {
				this._geoCity = cached.city || '';
				this.setZipField(cached.zip);
				this.quote(cached.zip, true, 'geo');
				return;
			}
			var controller = typeof AbortController === 'function' ? new AbortController() : null;
			var timer = controller ? setTimeout(function () { controller.abort(); }, 3000) : null;
			fetch(url, { credentials: 'omit', signal: controller ? controller.signal : undefined })
				.then(function (r) { return r.ok ? r.json() : null; })
				.then(function (g) {
					if (timer) { clearTimeout(timer); }
					if (!g || g.country !== 'US') { return; }
					var zip = cleanZip(g.postalCode);
					if (!zip || !stateForZip(zip) || NOT_SERVED[stateForZip(zip)]) { return; }
					try { sessionStorage.setItem('sae_geo', JSON.stringify({ zip: zip, city: g.city || '' })); } catch (e) { /* ignore */ }
					if (self.dataset.gateFree === 'true' || storedZip()) { return; }
					self._geoCity = g.city || '';
					self.setZipField(zip);
					self.quote(zip, true, 'geo');
				})
				.catch(function () { /* location service unavailable: stay on manual entry */ });
		}

		get ctx() {
			return this.dataset.context || 'page';
		}

		signature() {
			return [this.dataset.cartTotal, this.dataset.itemCount, this.dataset.freeTotal].join('|');
		}

		q(sel) {
			return this.querySelector(sel);
		}

		bind() {
			var self = this;
			var form = this.q('[data-sae-form]');
			var toggle = this.q('[data-sae-toggle]');

			var go = this.q('[data-sae-go]');
			var zipInput = this.q('[data-sae-zip]');

			// Button click and Enter key drive the quote directly; the form submit is only a fallback,
			// so nothing the theme (or a browser) does with form submission can swallow it.
			if (form && !form.__saeBound) {
				form.__saeBound = true;
				form.addEventListener('submit', function (e) {
					e.preventDefault();
					self.submitZip();
				});
			}
			if (go && !go.__saeBound) {
				go.__saeBound = true;
				go.addEventListener('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					self.submitZip();
				});
			}
			if (zipInput && !zipInput.__saeBound) {
				zipInput.__saeBound = true;
				zipInput.addEventListener('keydown', function (e) {
					if (e.key === 'Enter' || e.keyCode === 13) {
						e.preventDefault();
						e.stopPropagation();
						self.submitZip();
					}
				});
			}

			if (toggle && !toggle.__saeBound) {
				toggle.__saeBound = true;
				toggle.addEventListener('click', function () {
					self.showForm(true);
					var input = self.q('[data-sae-zip]');
					if (input) {
						input.focus();
					}
				});
			}
		}

		submitZip() {
			try {
				var input = this.q('[data-sae-zip]');
				var zip = cleanZip(input ? input.value : '');
				if (!zip) {
					this.showError('Enter a 5-digit US ZIP code.');
					return;
				}
				storeZip(zip);
				this.quote(zip, false, 'user');
			} catch (err) {
				if (window.console && window.console.warn) {
					console.warn('[shipping estimate]', err);
				}
				this.showError('Could not get a rate right now. Shipping is calculated at checkout.');
			}
		}

		setZipField(zip) {
			var input = this.q('[data-sae-zip]');
			if (input) {
				input.value = zip;
			}
		}

		showForm(show) {
			var form = this.q('[data-sae-form]');
			var prompt = this.q('[data-sae-prompt]');
			var toggle = this.q('[data-sae-toggle]');
			if (form) {
				form.hidden = !show;
			}
			if (prompt) {
				prompt.hidden = !show;
			}
			if (toggle) {
				toggle.hidden = show;
			}
		}

		setLoading(on) {
			this.classList.toggle('sae--loading', !!on);
			var btn = this.q('[data-sae-go]');
			if (btn) {
				btn.disabled = !!on;
				btn.textContent = on ? 'Checking' : 'Get rate';
			}
		}

		showError(msg) {
			var out = this.q('[data-sae-result]');
			if (out) {
				out.innerHTML = '<div class="sae__error">' + esc(msg) + '</div>';
			}
			this.showForm(true);
		}

		quote(zip, auto, source) {
			var self = this;
			this._source = source || (auto ? 'saved' : 'user');
			if (this._source !== 'geo') {
				this._geoCity = '';
			}
			var state = stateForZip(zip);

			if (!state) {
				if (!auto) {
					this.showError('Enter a valid 5-digit US ZIP code.');
				}
				return;
			}
			if (NOT_SERVED[state]) {
				this.showError('We ship to the 50 states and Washington, DC. Contact us for other destinations.');
				return;
			}

			var key = zip + '|' + this.signature();
			if (rateCache[key]) {
				this.render(rateCache[key], zip);
				return;
			}

			this._req = (this._req || 0) + 1;
			var req = this._req;
			this.setLoading(true);

			fetchRates(zip, state).then(function (res) {
				if (req !== self._req) {
					return;
				}
				if (res.status >= 400) {
					self.showError(errorMessage(res.data));
					return;
				}
				var rates = (res.data && res.data.shipping_rates) || [];
				if (res.status === 202 && !rates.length) {
					self.showError('UPS is still calculating this rate. Try again in a moment, or continue to checkout.');
					return;
				}
				rateCache[key] = rates;
				self.render(rates, zip);
			}).catch(function (err) {
				if (window.console && window.console.warn) {
					console.warn('[shipping estimate]', err);
				}
				if (req === self._req) {
					self.showError('Could not get a rate right now. Shipping is calculated at checkout.');
				}
			}).then(function () {
				if (req === self._req) {
					self.setLoading(false);
				}
			});
		}

		render(rates, zip) {
			var out = this.q('[data-sae-result]');
			if (!out) {
				return;
			}
			if (!rates.length) {
				this.showError('No shipping rates found for ZIP ' + zip + '. Contact us and we will quote it by hand.');
				return;
			}

			var sorted = rates.slice().sort(function (a, b) {
				return Number(a.price) - Number(b.price);
			});
			var best = sorted[0];
			var free = Number(best.price) === 0;
			var html = '';

			html += '<div class="sae__quote' + (free ? ' sae__quote--free' : '') + '">';
			html += '<strong>' + (free ? 'FREE Shipping' : esc(best.presentment_name || best.name) + ' ' + money(best.price)) + '</strong>';
			if (this._source === 'geo') {
				html += '<span>estimated for ZIP ' + esc(zip) + (this._geoCity ? ' (' + esc(this._geoCity) + ')' : '') + '</span>';
			} else {
				html += '<span>to ZIP ' + esc(zip) + '</span>';
			}
			html += '</div>';

			if (sorted.length > 1) {
				html += '<ul class="sae__alt">';
				for (var i = 1; i < sorted.length; i++) {
					var r = sorted[i];
					html += '<li>' + esc(r.presentment_name || r.name) + ' ' + money(r.price) + '</li>';
				}
				html += '</ul>';
			}

			html += '<button type="button" class="sae__link" data-sae-change>Change ZIP</button>';
			out.innerHTML = html;

			// A pre-ZIP "free" line must not sit above a paid quote (Alaska / Hawaii on free-profile items).
			var status = this.q('[data-sae-status]');
			if (status) {
				status.hidden = !free && this.dataset.gateFree === 'true';
			}

			this.showForm(false);
			var toggle = this.q('[data-sae-toggle]');
			if (toggle) {
				toggle.hidden = true;
			}

			var self = this;
			var change = out.querySelector('[data-sae-change]');
			if (change) {
				change.addEventListener('click', function () {
					out.innerHTML = '';
					if (status) {
						status.hidden = false;
					}
					self.showForm(true);
					var input = self.q('[data-sae-zip]');
					if (input) {
						input.focus();
						input.select();
					}
				});
			}
		}

		// Swap in freshly rendered Liquid (new cart totals / state), then re-quote.
		adopt(fresh) {
			if (!fresh) {
				return;
			}
			var names = fresh.getAttributeNames();
			for (var i = 0; i < names.length; i++) {
				var n = names[i];
				if (n === 'data-context' || n === 'class') {
					continue;
				}
				this.setAttribute(n, fresh.getAttribute(n));
			}
			// Keep our own context class, take the state class from the fresh render.
			var cls = fresh.className.split(/\s+/).filter(function (c) {
				return c && !/^sae--(page|drawer|refresh)$/.test(c);
			});
			cls.push('sae--' + this.ctx);
			this.className = cls.join(' ');
			this.innerHTML = fresh.innerHTML;
			this.bind();
			this.autoQuote();
		}

		onCartChanged(sections) {
			var self = this;
			var key = this.ctx === 'drawer' ? 'side-cart' : 'main-cart';
			var html = sections && sections[key];

			if (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var fresh = doc.querySelector('cart-shipping-estimate');
				if (fresh) {
					this.adopt(fresh);
					return;
				}
			}

			fetch('/cart?section_id=' + SECTION_ID, { credentials: 'same-origin' })
				.then(function (r) {
					return r.text();
				})
				.then(function (text) {
					var doc = new DOMParser().parseFromString(text, 'text/html');
					self.adopt(doc.querySelector('cart-shipping-estimate'));
				})
				.catch(function () { /* leave as is */ });
		}
	}

	if (!customElements.get('cart-shipping-estimate')) {
		customElements.define('cart-shipping-estimate', CartShippingEstimate);
	}

	// Watch the theme's cart requests so the estimate follows every cart change.
	var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
	var nativeFetch = window.fetch;
	var pending = null;

	function notify(sections) {
		clearTimeout(pending);
		pending = setTimeout(function () {
			var els = document.querySelectorAll('cart-shipping-estimate');
			for (var i = 0; i < els.length; i++) {
				els[i].onCartChanged(sections);
			}
		}, 250);
	}

	window.fetch = function (input, init) {
		var p = nativeFetch.apply(window, arguments);
		try {
			var url = typeof input === 'string' ? input : (input && input.url) || '';
			if (CART_URL.test(url)) {
				p.then(function (r) {
					if (!r || !r.ok) {
						return;
					}
					r.clone().json().then(function (data) {
						notify(data && data.sections ? data.sections : null);
					}).catch(function () {
						notify(null);
					});
				}).catch(function () { /* theme handles its own errors */ });
			}
		} catch (e) { /* never break the theme */ }
		return p;
	};
})();
